/**
 * Default package entry. Loads the four bundled locales (de/en/fr/hu) as
 * a side-effect on import, then re-exports the full core API. Importing
 * `@orgware/i18n-nationality` therefore yields a module where
 * `getName(...)`, `getNames(...)` etc. already work for those four
 * languages — matching the behaviour of the original CJS `entry-node.js`.
 *
 * Consumers who want the bare API (no built-in locales) can import from
 * `@orgware/i18n-nationality/core` instead.
 */
import { registerLocale } from './index.js'
import deLocale from '../langs/de.json' with { type: 'json' }
import enLocale from '../langs/en.json' with { type: 'json' }
import frLocale from '../langs/fr.json' with { type: 'json' }
import huLocale from '../langs/hu.json' with { type: 'json' }

for (const locale of [deLocale, enLocale, frLocale, huLocale]) {
  registerLocale(locale)
}

export * from './index.js'
